import { renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"])),
    onMousedown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pressing())),
    onMousemove: _cache[3] || (_cache[3] = ($event: any) => (_ctx.moving()))
  }, [
    _createElementVNode("div", {
      class: "modal__container",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      _renderSlot(_ctx.$slots, "header", {}, undefined, true),
      _renderSlot(_ctx.$slots, "subFilter", {}, undefined, true),
      _renderSlot(_ctx.$slots, "table", {}, undefined, true)
    ])
  ], 32))
}